import EventDashboardData from '@/components/event-dashboard/EventDashboardData'
import { SiteHeader } from '@/components/site-header'
import { useState } from 'react'

function EventDashboard() {
  const [searchQuery, setSearchQuery] = useState('')

  const handleSearchChange = (value: string) => {
    setSearchQuery(value)
  }

  return (
    <main
      className="@container/main flex flex-1 flex-col"
      id="main-content"
      tabIndex={-1}
      aria-label="Attendee Management Main Content"
    >
      <section
        aria-label="Attendee Management Header and Actions"
        className="flex flex-col gap-4 md:gap-6"
      >
        <SiteHeader
          title="Event Admin Dashboard"
          subtitle="Black Powder Festival 2024"
          searchPlaceholder="Search events..."
          searchValue={searchQuery}
          onSearchChange={handleSearchChange}
        />
      </section>

      <section aria-label="Attendees Data">
        <EventDashboardData searchTerm={searchQuery} />
      </section>
    </main>
  )
}

export default EventDashboard
